<span class="headline-medium"> Who are you? 🧐 </span>
<input
  matInput
  #displayNameInput
  autofocus
  placeholder="Display name"
  type="text"
  class="headline-large on-surface-text profile-name-input"
  (keyup.enter)="displayNameChosen(displayNameInput.value)"
/>
<button
  mat-flat-button
  (click)="displayNameChosen(displayNameInput.value)"
  [disabled]="loading()"
>
  @if (loading()) {
    <mat-spinner diameter="20"></mat-spinner>
  } @else {
    Done
  }
</button>
